export const KPI_PARAM_NAME = 'tagname'
